<div class="row text-grey ha-wrapper">
    <div class="col-md-5 ha-left">

        <form [formGroup]="haConfig" (ngSubmit)="onSubmit()" class="config-form">
            <h4>High Availability Configuration :</h4>
            <div class="haconfig p-3">
                <div class="w-50 d-flex gap-3 me-3">
                    <div class="useHa form-control d-flex justify-content-between align-items-center mb-3"
                        (click)="toggleHA()">
                        <span class="toggle-label">Use HA</span>
                        <div class="custom-toggle" [class.active]="haEnabled">
                            <div class="toggle-slider"></div>
                        </div>
                    </div>
                </div>
                <div class="primary">
                    <p>Primary Host Configuration</p>
                    <div class="d-flex gap-3">
                        <input type="text" formControlName="primaryHostName" class="form-control"
                            placeholder="Enter Primary HostName" />
                        <input type="text" formControlName="primaryHostIp" class="form-control"
                            placeholder="Enter Primary Host IP" />
                    </div>
                    <!-- Error messages for primary host -->
                    <div *ngIf="isFieldInvalid('primaryHostName')" class="text-danger small">
                        {{ getFieldError('primaryHostName') }}
                    </div>
                    <div *ngIf="isFieldInvalid('primaryHostIp')" class="text-danger small">
                        {{ getFieldError('primaryHostIp') }}
                    </div>
                </div>

                <mat-divider class="my-3"></mat-divider>

                <div class="secondary">
                    <p>Secondary Host Configuration </p>
                    <div class="d-flex gap-3">
                        <input type="text" formControlName="secondaryHostName" class="form-control"
                            placeholder="Enter Secondary HostName" />
                        <input type="text" formControlName="secondaryHostIp" class="form-control"
                            placeholder="Enter Secondary Host IP" />
                    </div>
                    <!-- Error messages for secondary host -->
                    <div *ngIf="isFieldInvalid('secondaryHostName')" class="text-danger small">
                        {{ getFieldError('secondaryHostName') }}
                    </div>
                    <div *ngIf="isFieldInvalid('secondaryHostIp')" class="text-danger small">
                        {{ getFieldError('secondaryHostIp') }}
                    </div>
                </div>

                <mat-divider class="my-3"></mat-divider>

                <div class="database">
                    <!-- <p>Database Configuration</p>
                    <mat-form-field class="w-100">
                        <mat-label>Database Type</mat-label>
                        <mat-select formControlName="dbType">
                            <mat-option *ngFor="let db of databaseTypes" [value]="db.value">
                                {{ db.label }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="isFieldInvalid('dbType')">
                            {{ getFieldError('dbType') }}
                        </mat-error>
                    </mat-form-field> -->

                    <div class="d-flex gap-3 me-3">
                        <div class="useHa form-control d-flex justify-content-between align-items-center mb-3"
                            (click)="toggleDBType()">
                            <span class="toggle-label">Sync Database with SyncHPC
                                <i class="bi bi-info-circle-fill"
                                    ngbTooltip="Currently only MSSQL EXPRESS is supported for HA"></i>
                            </span>
                            <div class="custom-toggle" [class.active]="dbtypeEnabled">
                                <div class="toggle-slider"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex gap-2">
                    <button type="submit" class="btn btn-primary mt-2"
                        [disabled]="!haConfig || haConfig.invalid || isSaving">
                        {{ isSaving ? 'Saving...' : 'Save Configuration' }}
                    </button>
                </div>
            </div>
        </form>

            <!-- Advanced Options Section -->
            <mat-expansion-panel class="advanced-options-panel my-3 mb-5">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Advanced Options
                    </mat-panel-title>
                    <mat-panel-description>
                        System maintenance operations
                    </mat-panel-description>
                </mat-expansion-panel-header>
                
                <div class="advanced-content">
                    <div class="reset-warning-card">
                        <div class="warning-header">
                            <mat-icon class="warning-icon">warning</mat-icon>
                            <strong>Maintenance Operations</strong>
                        </div>
                        <p class="warning-text">
                            These operations are intended for system maintenance and development purposes only.
                        </p>
                    </div>
                    
                    <div class="reset-action-row">
                        <div class="reset-description">
                            <div class="reset-title">Make Current Host Primary</div>
                            <div class="reset-subtitle">Switch primary role to this host ({{ currentHostIp }})</div>
                        </div>
                        <button mat-raised-button 
                                color="primary" 
                                class="primary-button"
                                [disabled]="isMakingPrimary"
                                (click)="openMakePrimaryConfirmation()">
                            <mat-icon>swap_horiz</mat-icon>
                            {{ isMakingPrimary ? 'Switching...' : 'Make Primary' }}
                        </button>
                    </div>

                    <mat-divider class="my-3"></mat-divider>

                    <div class="reset-action-row">
                        <div class="reset-description">
                            <div class="reset-title">Reset HA System</div>
                            <div class="reset-subtitle">Completely reset HA configuration on both hosts</div>
                        </div>
                        <button mat-raised-button 
                                color="warn" 
                                class="reset-button"
                                [disabled]="isResetting"
                                (click)="openResetConfirmation()">
                            <mat-icon>delete</mat-icon>
                            {{ isResetting ? 'Resetting...' : 'Reset' }}
                        </button>
                    </div>

                </div>
            </mat-expansion-panel>

            <!-- ! Temporary Disabled -->
            <!-- <mat-divider class="my-1"></mat-divider> -->
<!--  -->
            <!--Already disabled <div class="p-3 py-1 dbLinking" *ngIf="primaryToSecondaryLinking != null || secondaryToPrimaryLinking != null"> -->
            <!-- <div class="p-3 py-1 dbLinking haconfig" [class.disabled-content]="!shouldShowDataDBLinking"> -->
                <!-- <h4 class="mb-2" *ngIf="!primaryToSecondaryLinking || !secondaryToPrimaryLinking">Database Linking -->
                    <!-- Status :</h4> -->
                <!-- <div class="linking-item-wrapper row" style="font-size: 13px"> -->
                    <!-- Primary to Secondary -->
                    <!-- Already disabled<div class="linking-item" *ngIf="!primaryToSecondaryLinking" [class.loading]="isConfiguringPrimary" (click)="configureLinking('primary-to-secondary')"> -->
                    <!-- <div class="linking-item m-1" [class.loading]="isConfiguringPrimary" -->
                        <!-- (click)="configureLinking('primary-to-secondary')"> -->
<!--  -->
                        <!-- <div class="connection-status" [class.connected]="primaryToSecondaryLinking"></div> -->
<!--  -->
                        <!-- <div class="linking-content"> -->
                            <!-- <div class="server-info"> -->
                                <!-- <div class="server-name"> -->
                                    <!-- <span [ngbTooltip]="primaryHostName"> -->
                                        <!-- {{ primaryHostName | shortenString : 120}} -->
                                    <!-- </span> -->
                                    <!-- : {{ primaryHostIp }} -->
                                <!-- </div> -->
                            <!-- </div> -->
<!--  -->
                            <!-- <div class="arrow-container"> -->
                                <!-- <div class="arrow"> -->
                                    <!-- <div class="arrow-animation"></div> -->
                                <!-- </div> -->
                            <!-- </div> -->
<!--  -->
                            <!-- <div class="server-info"> -->
                                <!-- <div class="server-name"> -->
                                    <!-- <span [ngbTooltip]="secondaryHostName"> -->
                                        <!-- {{ secondaryHostName | shortenString : 120}} -->
                                    <!-- </span> -->
                                    <!-- : {{ secondaryHostIp }} -->
                                <!-- </div> -->
                            <!-- </div> -->
                        <!-- </div> -->
                    <!-- </div> -->
                    <!-- Secondary to Primary -->
                    <!-- Already Disabled <div class="linking-item" *ngIf="!secondaryToPrimaryLinking" [class.loading]="isConfiguringSecondary" (click)="configureLinking('secondary-to-primary')"> -->
                    <!-- <div class="linking-item m-1" [class.loading]="isConfiguringSecondary" -->
                        <!-- (click)="configureLinking('secondary-to-primary')"> -->
<!--  -->
                        <!-- <div class="connection-status" [class.connected]="secondaryToPrimaryLinking"></div> -->
<!--  -->
                        <!-- <div class="linking-content"> -->
                            <!-- <div class="server-info"> -->
                                <!-- <div class="server-name"> -->
                                    <!-- <span [ngbTooltip]="secondaryHostName"> -->
                                        <!-- {{ secondaryHostName | shortenString : 120}} -->
                                    <!-- </span> -->
                                    <!-- : {{ secondaryHostIp }} -->
                                <!-- </div> -->
                            <!-- </div> -->
<!--  -->
                            <!-- <div class="arrow-container"> -->
                                <!-- <div class="arrow"> -->
                                    <!-- <div class="arrow-animation"></div> -->
                                <!-- </div> -->
                            <!-- </div> -->
<!--  -->
                            <!-- <div class="server-info"> -->
                                <!-- <div class="server-name"> -->
                                    <!-- <span [ngbTooltip]="primaryHostName"> -->
                                        <!-- {{ primaryHostName | shortenString : 120}} -->
                                    <!-- </span> -->
                                    <!-- : {{ primaryHostIp }} -->
                                <!-- </div> -->
                            <!-- </div> -->
                        <!-- </div> -->
                    <!-- </div> -->
                <!-- </div> -->
            <!-- </div> -->

    </div>

    <div class="col-md-7 ha-right">
        <div class="config-info p-3 py-1" [class.disabled-content]="!shouldShowDataHostInfo">
            <h4>Host Information :</h4>
            <div class="HostInfo">
                <div class="host-cards-container my-3">
                    <!-- Primary Host Card -->
                    <div class="host-card"  [ngClass]="getHostStatusClasses(primaryHost?.status)">
                        <div class="card-content">
                            <div class="host-info">
                                <div class="host-type-indicator " 
                                                [ngClass]="{
                                                'primary': isCurrentHost(primaryHost) ? true : false,
                                                'secondary': isCurrentHost(primaryHost) ? false : true,
                                                'current-host-dot': isCurrentHost(primaryHost)
                                                }"
                                                [ngbTooltip]="isCurrentHost(primaryHost) ? 'Current Host' : ''"
                                                container="body"
                                                [openDelay]="0"
                                                [closeDelay]="500"
                                                placement="left">
                                </div>
                                <div class="host-details">
                                    <div class="host-main">
                                        <span class="host-name">{{ primaryHost?.hostName || 'Primary Host' }}</span>
                                        <span class="host-type">Primary</span>
                                        <i *ngIf="isCurrentHost(primaryHost)" 
                                            class="bi bi-geo-alt-fill current-host-icon"
                                            ngbTooltip="You are here"
                                            container="body">
                                        </i>
                                    </div>
                                    <div class="host-ip">{{ primaryHost?.hostIp || 'N/A' }}</div>
                                </div>
                            </div>

                            <div class="host-status">
                              
                                <div class="status-indicator">
                                    <div class="status-dot" [ngClass]="primaryHost?.status?.toLowerCase()"></div>
                                    <span class="status-text">{{ getHostStateText(primaryHost?.status) }}</span>
                                </div>
                                <div class="last-updated">
                                    Up Time: {{ formatDate(primaryHost?.lastUpTime) }}
                                </div>
                                <button class="check-btn" (click)="checkHost('primary')"
                                    [disabled]="isChecking || isCurrentHost(primaryHost)">
                                    {{ isChecking && checkingHost === 'primary' ? 'Checking...' : 'Check' }}
                                </button>
                            </div>
                        </div>
                    </div><!--End Primary Host Card -->

                    <!-- Secondary Host Card -->
                    <div class="host-card"  [ngClass]="getHostStatusClasses(secondaryHost?.status)">
                        <div class="card-content">
                            <div class="host-info">
                                <div class="host-type-indicator" 
                                            [ngClass]="{
                                            'primary': isCurrentHost(secondaryHost) ? true : false,
                                            'secondary': isCurrentHost(secondaryHost) ? false : true,
                                            'current-host-dot': isCurrentHost(secondaryHost)
                                            }"
                                            [ngbTooltip]="isCurrentHost(secondaryHost) ? 'Current Host' : ''"
                                            container="body"
                                            [openDelay]="0"
                                            [closeDelay]="500"
                                            placement="left">
                                </div>
                                <div class="host-details">
                                    <div class="host-main">
                                        <span class="host-name">{{ secondaryHost?.hostName || 'Secondary Host' }}</span>
                                        <span class="host-type">Secondary</span>
                                        <i *ngIf="isCurrentHost(secondaryHost)" 
                                            class="bi bi-geo-alt-fill current-host-icon"
                                            ngbTooltip="You are here"
                                            container="body">
                                        </i>
                                    </div>
                                    <div class="host-ip">{{ secondaryHost?.hostIp || 'N/A' }}</div>
                                </div>
                            </div>

                            <div class="host-status">
                                
                                <div class="status-indicator">
                                    <div class="status-dot" [ngClass]="secondaryHost?.status?.toLowerCase()"></div>
                                    <span class="status-text">{{ getHostStateText(secondaryHost?.status) }}</span>
                                </div>
                                <div class="last-updated">
                                    Up Time: {{ formatDate(secondaryHost?.lastUpTime) }}
                                </div>
                                <button class="check-btn" (click)="checkHost('secondary')"
                                    [disabled]="isChecking || isCurrentHost(secondaryHost)">
                                    {{ isChecking && checkingHost === 'secondary' ? 'Checking...' : 'Check' }}
                                </button>
                            </div>
                        </div>
                    </div><!--End Secondary Host Card -->
                </div><!--End Host Cards Container -->
            </div><!--End Host Info -->
        </div><!--End Config Info -->

        <mat-divider class="my-1"></mat-divider>

        <div class="p-3 syncStatus-container py-1 mb-3">
            <h4 [class.disabled-content]="!shouldShowData">Sync Status :</h4>
            <div class="row syncStatus" [class.disabled-content]="!shouldShowData">
                <div class="col-md-6 p-2">
                    <div class="sync-status-item card border border-1 rounded-3" id="dbSync">
                        <div class="card-body">
                            <h5 class="card-title">
                                Database Sync Status
                            </h5>
                            <div class="indicator float-end d-flex align-items-center gap-1">
                                <span class="ms-1">{{ syncStatus?.IsDBSyncRunning ? 'Running' : 'Stopped' }}</span>
                                <div class="status-dot" [ngClass]="syncStatus?.IsDBSyncRunning? 'active' : 'inactive'">
                                </div>
                            </div>
                            <p class="card-text">{{ syncStatus?.DBMessage }}</p>
                            <p class="card-text">Last Sync Time: {{ syncStatus?.DBLastSyncTime }}</p>
                            <div class="syncButtons d-flex justify-content-between mt-2">
                                <button class="btn btn-primary btn-sm" *ngIf="!syncStatus?.IsDBSyncRunning"
                                    (click)="startDBSync()" [disabled]="isStartingDBSync">
                                    {{ isStartingDBSync ? 'Starting...' : 'Start Sync' }}
                                </button>
                                <button class="btn btn-primary btn-sm" *ngIf="syncStatus?.IsDBSyncRunning"
                                    (click)="stopDBSync()" [disabled]="isStartingDBSync">
                                    {{ isStopingDBSync ? 'Stoping...' : 'Stop Sync' }}
                                </button>
                                <button class="btn btn-primary btn-sm" (click)="manualDBSync()"
                                    [disabled]="isManualDBSync">
                                    {{ isManualDBSync ? 'Syncing...' : 'Manual Sync' }}
                                </button>
                            </div><!-- syncButtons end-->
                        </div><!--End card-body-->
                    </div><!--End DB Sync Status-->
                </div>
                <div class="col-md-6 p-2">
                    <div class="sync-status-item card border border-1 rounded-3" id="fsSync">
                        <div class="card-body">
                            <h5 class="card-title">
                                Config Files Sync Status
                            </h5>
                            <div class="indicator float-end d-flex align-items-center gap-1">
                                <span class="ms-1">{{ syncStatus?.IsFSSyncRunning ? 'Running' : 'Stopped' }}</span>
                                <div class="status-dot" [ngClass]="syncStatus?.IsFSSyncRunning? 'active' : 'inactive'">
                                </div>
                            </div>
                            <p class="card-text">{{ syncStatus?.FSMessage }}</p>
                            <p class="card-text">Last Sync Time: {{ syncStatus?.FSLastSyncTime }}</p>
                            <div class="syncButtons d-flex justify-content-between mt-2">
                                <button class="btn btn-primary btn-sm" *ngIf="!syncStatus?.IsFSSyncRunning"
                                    (click)="startFSSync()" [disabled]="isStartingFSSync">
                                    {{ isStartingFSSync ? 'Starting...' : 'Start Sync' }}
                                </button>
                                <button class="btn btn-primary btn-sm" *ngIf="syncStatus?.IsFSSyncRunning"
                                    (click)="stopFSSync()" [disabled]="isStopingFSSync">
                                    {{ isStopingFSSync ? 'Stoping...' : 'Stop Sync' }}
                                </button>
                                <button class="btn btn-primary btn-sm" (click)="manualFSSync()"
                                    [disabled]="isManualFSSync">
                                    {{ isManualFSSync ? 'Syncing...' : 'Manual Sync' }}
                                </button>
                            </div><!-- syncButtons end-->
                        </div><!--End card-body-->
                    </div><!--End FS Sync Status-->
                </div>
            
                <div class="col-md-6 p-2">
                    <div class="sync-status-item card border border-1 rounded-3" id="jobsSync">
                        <div class="card-body">
                            <h5 class="card-title">
                                Jobs Sync Status
                            </h5>
                            <div class="indicator float-end d-flex align-items-center gap-1">
                                <span class="ms-1">{{ syncStatus?.IsJobsSyncRunning ? 'Running' : 'Stopped' }}</span>
                                <div class="status-dot" [ngClass]="syncStatus?.IsJobsSyncRunning? 'active' : 'inactive'">
                                </div>
                            </div>
                            <p class="card-text">{{ syncStatus?.JobsSyncMessage }}</p>
                            <p class="card-text">Last Sync Time: {{ syncStatus?.JobsSyncLastSyncTime }}</p>
                            <div class="syncButtons d-flex justify-content-between mt-2">
                                <button class="btn btn-primary btn-sm" *ngIf="!syncStatus?.IsJobsSyncRunning"
                                    (click)="startJobsSync()" [disabled]="isStartingJobsSync">
                                    {{ isStartingJobsSync ? 'Starting...' : 'Start Sync' }}
                                </button>
                                <button class="btn btn-primary btn-sm" *ngIf="syncStatus?.IsJobsSyncRunning"
                                    (click)="stopJobsSync()" [disabled]="isStopingJobsSync">
                                    {{ isStopingJobsSync ? 'Stoping...' : 'Stop Sync' }}
                                </button>
                                <button class="btn btn-primary btn-sm" (click)="manualJobsSync()"
                                    [disabled]="isManualJobsSync">
                                    {{ isManualJobsSync ? 'Syncing...' : 'Manual Sync' }}
                                </button>
                            </div><!-- syncButtons end-->
                        </div><!--End card-body-->
                    </div><!--End Jobs Sync Status-->
                </div>
            
            </div>

            <!-- <div class="linked-servers-container p-3 py-1" [class.disabled-content]="!shouldShowDataServerInfo">
                <h4>Linked Server Information :</h4>

                <div class="row linked-servers-grid" *ngIf="linkedServerInfo?.length">
                    <div class="col-md-6 p-2" *ngFor="let link of linkedServerInfo; let i = index">
                        <div class="linked-server-card card border border-1 rounded-3">
                            <div class="card-body">
                                <div class="server-header d-flex justify-content-between align-items-center mb-3">
                                    <h5 class="card-title mb-0">
                                        <i class="bi bi-server"></i>
                                        Linked Server #{{i + 1}}
                                    </h5>
                                    <div class="connection-status-badge">
                                        <div class="status-dot active"></div>
                                        <span class="status-label">Connected</span>
                                    </div>
                                </div>

                                <div class="server-details">
                                    <div class="detail-row">
                                        <span class="detail-label">Server Name:</span>
                                        <span class="detail-value">{{ link.linkedServerName || 'N/A' }}</span>
                                    </div>

                                    <div class="detail-row">
                                        <span class="detail-label">Server Address:</span>
                                        <span class="detail-value server-address">{{ link.serverAddress || 'N/A'
                                            }}</span>
                                    </div>

                                    <div class="detail-row">
                                        <span class="detail-label">Product:</span>
                                        <span class="detail-value">{{ link.productName || 'Unknown' }}</span>
                                    </div>

                                    <div class="detail-row">
                                        <span class="detail-label">Last Modified:</span>
                                        <span class="detail-value">{{ link.modifyDate | date:'short' || 'N/A' }}</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div> 
            </div>

            <div *ngIf="!linkedServerInfo?.length" class="no-servers-placeholder p-3 py-1">
                <div class="empty-state-card card border-2 border-dashed">
                    <div class="card-body text-center py-5">
                        <i class="bi bi-server display-5 text-muted mb-3"></i>
                        <h5 class="text-muted">No Linked Servers Found</h5>
                        <p class="text-muted mb-0">Configure database linking to see connected servers here.</p>
                    </div>
                </div>
            </div> -->

        </div>

    </div>

</div>
<ngx-spinner bdColor="rgba(0,0,0,0)" size="default" zIndex="1" color="var(--s-primary-color)" type="ball-spin"
    [fullScreen]="false" name="haConfigSpinner">
    <p>Please wait ...</p>
</ngx-spinner>